<app-view-dashboard-component>
  <div modalTitle>

  </div>
  <div>
    <app-month-switch [current]="endDate$ | async"
      (monthChange)="changeMonth($event)"></app-month-switch>
  </div>
  @for (item of usages$ | async; track $index) {
    <div class="grid">
      <ion-item lines="none">
        <div> {{ item.contractor?.name ?? item.guid }}</div>
      </ion-item>
      @if (item.maxTokens$ | async; as maxTokens) {
        <ion-item lines="none">
          <ion-icon slot="start"
            name="arrow-forward-outline"></ion-icon>
          <div>{{ item.usage?.prompt_tokens ?? '-' }} / {{ maxTokens.input }}</div>
        </ion-item>
        <ion-item lines="none">
          <ion-icon slot="start"
            name="arrow-back-outline"></ion-icon>
          <div>{{ item.usage?.completion_tokens ?? '-' }} / {{ maxTokens.output }}</div>
        </ion-item>
      }
    </div>
  }
</app-view-dashboard-component>